import SameCompUse from "../../components/reportsSame/SameCompUse"

export const SameReportsPage = ({ title_1, title_2, title }) => {
   
    return <div>
        <SameCompUse title_1={title_1} title_2={title_2} title={title} />
    </div>
}